import { Component, computed, input } from '@angular/core';

@Component({
	selector: 'lvr-spacer',
	template: `<div
		[style.height.px]="height()"
		[style.padding]="padding()"
		[style.margin]="margin()"
		[style.border-bottom]="border()"
	></div>`,
	styles: [
		`
			div {
				width: 100%;
			}
		`,
	],
})
export class LvrSpacer {
	public readonly height = input<number>(16);
	public readonly padding = input<string>('');
	public readonly margin = input<string>('');
	public readonly color = input<string>('transparent');

	public readonly border = computed(() => (this.color() !== 'transparent' ? `1px solid ${this.color()}` : 'none'));
}
